<template>
    <div>
        <v-dialog v-model="opnSftMeeting" width="650px" persistent>
            <v-card>
                <v-toolbar dense dark color="secondary">
                    <v-spacer />
                    <v-toolbar-title class="white--text">New Safety Meetings</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-container grid-list-xs fluid>
                    <v-row>
                        <v-col>
                            <v-combobox v-model="region" :items="regions" :item-text="'PrincipalRegion'" :item-value="'PrincipalRegionID'"
                                auto-select-first label="Select a Region" hide-details dense
                               ></v-combobox>
                        </v-col>
                        <v-col>
                            <v-text-field
                                label="Safety Meeting"
                                dense
                                hide-details
                                placeholder="YYYY-MM"
                                v-model="sftMt"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="end">
                        <v-btn @click="createSftMetting" class="mb-3 mr-3" color="success">Save</v-btn>
                    </v-row>
                </v-container>
            </v-card>
            <confirm-dialogue ref="confirmDialogue" style="z-index: 100;"></confirm-dialogue>
        </v-dialog>
    </div>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from "axios";
import ConfirmDialogue from './../../ConfirmDialogue.vue';
export default {
    directives: { mask },
    components: {
        ConfirmDialogue
    },
    props: ['place', 'url', 'opnSftMeeting', 'parms', 'fld'],
    data: function () {
        return {
            sftMt: '',
            regions:[],
            region:'' 
        }
    },
    methods: {
        // save: function(){
        //     
        //     console.log(this.parms);
        // },

        async createSftMetting() {
                const ok = await this.$refs.confirmDialogue.show({
                    title: 'When the safety meeting is created, it will be attached to the available drivers in the selected region',
                    message: 'Are you sure?',
                    okButton: 'Yes',
                    cancelButton: 'No'
                });
                // If you throw an error, the method will terminate here unless you surround it wil try/catch
                if (ok) {
                    this.save(1);
                }else{
                    this.save(0);

                }
        },

        save: function (mtl) {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Region: this.region.PrincipalRegionID,
                Name : this.sftMt,
                Multiple: mtl
            }
            axios
                .post('safety-meeting', parms,{
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.$emit('closeUpd');
                    this.$emit('close');
                    console.log(response);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    str.state.isLoading = false;
                });
        },
        getRegions() {
            this.$store.state.isLoading = false;
            axios
                .get('region', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.regions = response.data;
                })
                .catch(error => {
                    // logErr(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });
        },
    },    
    mounted() {
        this.getRegions();
    },
}
</script>